import { FC } from "react";

const BINDINGS: [string, string][] = [
  ["b / s", "Switch the ticket to buy / sell and focus the amount"],
  ["Enter", "Place the order in the ticket (from the amount or price field)"],
  ["r", "Fill the ticket with your last order — review, Enter to place"],
  ["shift + R", "Fill the inverse of your last order (sell what you bought)"],
  ["shift + C", "Cancel every open order — press twice to confirm"],
  ["ctrl + 1–5", "Switch market (where the browser allows it)"],
  ["?", "Show or hide this cheatsheet"],
];

interface HotkeyCheatsheetProps {
  open: boolean;
  onClose: () => void;
  hotkeysEnabled: boolean;
  onToggleHotkeys: (enabled: boolean) => void;
}

/** The `?` overlay: hotkey reference plus the enable/disable preference (the
 * one place hotkeys are documented is the one place they're controlled). */
export const HotkeyCheatsheet: FC<HotkeyCheatsheetProps> = ({
  open,
  onClose,
  hotkeysEnabled,
  onToggleHotkeys,
}) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Keyboard shortcuts"
      onClick={onClose}
    >
      <div
        className="sr-panel w-full max-w-lg p-6"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="mb-4 flex items-center justify-between">
          <h2 className="font-display text-lg font-medium text-white">
            Keyboard shortcuts
          </h2>
          <button
            type="button"
            className="sr-focus-ring rounded-md px-2 py-1 text-sm text-sr-neutral-400 transition-colors hover:text-white"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <div className={`grid grid-cols-[7.5rem_1fr] items-baseline gap-x-4 gap-y-3 ${hotkeysEnabled ? "" : "opacity-40"}`}>
          {BINDINGS.map(([keys, description]) => (
            <div key={keys} className="contents">
              <kbd className="justify-self-start rounded-md border border-sr-border-subtle bg-white/5 px-2 py-0.5 font-mono text-xs text-sr-lemon-muted whitespace-nowrap">
                {keys}
              </kbd>
              <span className="text-sm text-sr-neutral-300">{description}</span>
            </div>
          ))}
        </div>

        <label className="mt-5 flex cursor-pointer items-center justify-between gap-3 border-t border-sr-border-subtle pt-4">
          <span className="text-sm text-sr-neutral-300">Enable trading hotkeys</span>
          <input
            type="checkbox"
            checked={hotkeysEnabled}
            onChange={(event) => onToggleHotkeys(event.target.checked)}
            className="sr-focus-ring h-4 w-4 accent-sr-pink-muted"
          />
        </label>
      </div>
    </div>
  );
};
